function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.4,
  d: "M29.3334 9.9069V17.9069C29.3334 19.9069 28.6667 21.5736 27.4934 22.7469C26.3334 23.9069 24.6667 24.5736 22.6667 24.5736V27.4136C22.6667 28.4802 21.4801 29.1203 20.6001 28.5336L14.6667 24.5736H11.8401C11.9468 24.1736 12.0001 23.7602 12.0001 23.3336C12.0001 21.9736 11.4801 20.7203 10.6267 19.7736C9.66675 18.6803 8.24008 18.0002 6.66675 18.0002C5.17341 18.0002 3.81342 18.6136 2.84009 19.6136C2.72009 19.0803 2.66675 18.5069 2.66675 17.9069V9.9069C2.66675 5.9069 5.33341 3.24023 9.33342 3.24023H22.6667C26.6667 3.24023 29.3334 5.9069 29.3334 9.9069Z",
  fill: "#ED880F"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M20.6666 15H11.3333C10.7866 15 10.3333 14.5467 10.3333 14C10.3333 13.4533 10.7866 13 11.3333 13H20.6666C21.2133 13 21.6666 13.4533 21.6666 14C21.6666 14.5467 21.2133 15 20.6666 15Z",
  fill: "#ED880F"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M6.66659 18C5.41325 18 4.25325 18.44 3.33325 19.1733C2.10659 20.1467 1.33325 21.6533 1.33325 23.3333C1.33325 26.28 3.71992 28.6667 6.66659 28.6667C8.01325 28.6667 9.23994 28.16 10.1866 27.3333C11.2933 26.36 11.9999 24.9333 11.9999 23.3333C11.9999 20.3867 9.61325 18 6.66659 18ZM7.99992 23.6667C7.99992 24.0133 7.81327 24.3467 7.51994 24.52L5.85327 25.52C5.69327 25.6134 5.51992 25.6667 5.33325 25.6667C4.99992 25.6667 4.66657 25.4934 4.4799 25.1867C4.1999 24.7067 4.34658 24.0933 4.82658 23.8133L6.01327 23.1067V21.6667C6.01327 21.12 6.4666 20.6667 7.01327 20.6667C7.55993 20.6667 8.01327 21.12 8.01327 21.6667V23.6667H7.99992Z",
  fill: "#ED880F"
});

function SvgIncompleteInterviews(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncompleteInterviews);
export default __webpack_public_path__ + "static/media/incomplete-interviews.2c0c5335.svg";
export { ForwardRef as ReactComponent };